// extracted by mini-css-extract-plugin
export default {"skeletonNode":"DraftPageSkeleton_skeletonNode__miRNx"};